export default "__VITE_ASSET__b34861f2__"